/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 17:23:14
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-18 11:03:04
 * @Description: file content
 */
export default {
    env: {
        test: {
            site: {
                appid: "",
                protocol: "",
                domain: "",
            },
            routersActWxauth: {
                fake: {
                    zt: {
                        actOpenId: 'oj3y9wJIWmCfZ90py4wJR5qT5c8o',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    ljf: {
                        actOpenId: 'oj3y9wJASe2OqpMUHyJ-8hsxsNvE',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    df: {
                        actOpenId: 'oj3y9wBrjK0w4pf04S3m_Pp6Ufhw',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    wj: {
                        actOpenId: 'oj3y9wNQ09AnwOAlaDkcPfqjMoUs',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    test: {
                        actOpenId: 'oj3y9wNom04YJrnwEBMlTsIfNLCY',
                        actAppId: 'wx01f0b018d4951434',
                    }
                }
            },
            servicesActWxjssdk: {
                appid: 'wx01f0b018d4951434',
            },
            apiActLogicDengfan: {
                protocol: "",
                domain: "",
            },
            apiActLogicZouTeng: {
                protocol: "",
                domain: "",
            },
            httpActLogicDengfan: {
                appId: "",
                infoId: 1,
            },
            httpActLogicZouTeng: {
                appId: "",
                infoId: 1,
            },
        },
        prod: {
            site: {
                appid: "",
                protocol: "",
                domain: "",
            },
            routersActWxauth: {
                fake: {
                    zt: {
                        actOpenId: 'oj3y9wJIWmCfZ90py4wJR5qT5c8o',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    ljf: {
                        actOpenId: 'oj3y9wJASe2OqpMUHyJ-8hsxsNvE',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    df: {
                        actOpenId: 'oj3y9wBrjK0w4pf04S3m_Pp6Ufhw',
                        actAppId: 'wx01f0b018d4951434',
                    },
                    wj: {
                        actOpenId: 'oj3y9wNQ09AnwOAlaDkcPfqjMoUs',
                        actAppId: 'wx01f0b018d4951434',
                    }
                }
            },
            servicesActWxjssdk: {
                appid: 'wx01f0b018d4951434',
            },
            apiActLogicDengfan: {
                protocol: "",
                domain: "",
            },
            apiActLogicZouTeng: {
                protocol: "",
                domain: "",
            },
            httpActLogicDengfan: {
                appId: "",
                infoId: 1,
            },
            httpActLogicZouTeng: {
                appId: "",
                infoId: 1,
            },
        }
    },
};